export class GroupDropDownItem {
    displayName: any;
    expanded: boolean;
    selected: boolean;
    groupItem: boolean;
    value: any;
    item: any;
    items: GroupDropDownItem[];
    parent: GroupDropDownItem;
}
